import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../../button/index.js';
import { SelectListMobile, LabelContainer, SelectListContent, FocusTrap, ChildrenContainer, ButtonContainer, SelectListPlacement, SelectListContainer } from './styles.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { KeyCodes } from '../../../enumerations/key-codes.js';

const SelectList = _ref => {
  let {
    children,
    label,
    textSubmit,
    isExpanded,
    isLoading,
    isMobile,
    hasActions,
    onRefList,
    onSubmit,
    onEscape,
    onWrap
  } = _ref;
  const refListPlacement = useRef(null);
  const refListContainer = useRef(null);
  const handleButtonKeyDown = event => {
    switch (event.which) {
      case KeyCodes.Escape:
        event.preventDefault();
        onEscape?.();
        break;
    }
  };
  useEffect(() => {
    if (isMobile) {
      onRefList && refListPlacement && onRefList(refListPlacement);
    } else {
      onRefList && refListContainer && onRefList(refListContainer);
    }
  }, [isMobile]);
  return isMobile ? ( /*#__PURE__*/createPortal(
  
  // eslint-disable-next-line jsx-a11y/role-supports-aria-props
  jsxs(SelectListMobile, {
    isExpanded: isExpanded,
    "aria-hidden": !isExpanded,
    children: [/*#__PURE__*/jsx(LabelContainer, {
      children: label
    }), /*#__PURE__*/jsxs(SelectListContent, {
      children: [/*#__PURE__*/jsx(FocusTrap, {
        onFocus: onWrap,
        tabIndex: isExpanded ? 0 : -1,
        "aria-hidden": true
      }), /*#__PURE__*/jsx(ChildrenContainer, {
        children: children
      }), /*#__PURE__*/jsxs(ButtonContainer, {
        children: [/*#__PURE__*/jsx(Button, {
          fullWidth: true,
          onClick: onSubmit,
          onKeyDown: handleButtonKeyDown,
          children: textSubmit
        }), /*#__PURE__*/jsx(FocusTrap, {
          onFocus: onWrap,
          tabIndex: isExpanded ? 0 : -1,
          "aria-hidden": true
        })]
      })]
    })]
  }), document.body)) : /*#__PURE__*/jsx(SelectListPlacement, {
    ref: refListPlacement,
    children: /*#__PURE__*/jsxs(SelectListContainer, {
      ref: refListContainer,
      isExpanded: isExpanded,
      isLoading: isLoading,
      hasActions: hasActions,
      "aria-hidden": !isExpanded,
      children: [/*#__PURE__*/jsx(FocusTrap, {
        onFocus: onWrap,
        tabIndex: isExpanded ? 0 : -1,
        "aria-hidden": true
      }), children, /*#__PURE__*/jsx(FocusTrap, {
        onFocus: onWrap,
        tabIndex: isExpanded ? 0 : -1,
        "aria-hidden": true
      })]
    })
  });
};

export { SelectList };
//# sourceMappingURL=component.js.map
